import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";
import createUserRoleSaga from "./sagas";

const actions = prepActions(service);
const userRoleSagas = createController(service, actions);

export { createUserRoleSaga, userRoleSagas, actions };
